export default "__VITE_ASSET__D8sQXF5A__"